import user from './user';
import manage from './manage';

const api = {
    user, // 用户类
    manage, // 普通接口类
}

export default api;